import { isUSDCryptoSymbol } from '@benzinga/crypto-manager';
import { Watchlist } from '@benzinga/watchlist-manager';

export const isCryptoOnlyWatchlist = (watchlist?: Watchlist | null): boolean => {
  const symbols = watchlist?.symbols ?? [];
  return symbols.length > 0 && symbols.every(({ symbol }) => isUSDCryptoSymbol(symbol));
};
